import { connect } from "react-redux";
import { useEffect, useMemo, useRef, useState } from "react";
import { withNamespaces } from "react-i18next";
import TableFilter from "src/components/TableFilter";
import { RoleOptions } from "./RoleOptions";

const FilteringComponent = ({
    onChange,
    modules: {
        active: activeModule
    }
}) => {
    const [ tableFilters, setTableFilters ] = useState({
        role: [],
        name: undefined
    });
    const initRef = useRef(false);

    const roleOptions = useMemo(() => {
        return (RoleOptions(activeModule) || []).map((item) => ({...item, id: item.value}));
    }, [ activeModule ]);

    const tableFilterTabs = useMemo(() => {
        return [
            {
                type: 'check_list',
                name: 'role',
                title: 'Role',
                icon: <i className="ri-user-line" />,
                isLoading: false,
                defaultValue: tableFilters?.role,
                data: roleOptions || [],
                searchInListOption: {
                    enabled: true,
                    remote: false
                },
                formatter: (item) => {
                    return item.label
                }
            },
            {
                type: 'search_textbox',
                name: 'name',
                title: 'Search',
                icon: <i className="ri-search-2-line" />,
                defaultValue: tableFilters?.name,
                options: {
                    placeholder: 'Search in users'
                },
            }
        ]
    }, [
        tableFilters,
        roleOptions
    ]);

    const onTableFilterOkButtonClicked = (filters) => {
        if (filters) {
            const result = {}

            result.role = filters.role?.length > 0 ? filters.role : undefined;

            if('name' in filters) {
                result.name = filters.name || undefined;
            }

            setTableFilters({
                ...tableFilters,
                ...result
            })
        } else {
            setTableFilters({
                role: [],
                name: undefined
            })
        }
    }

    useEffect(() => {
        if(!initRef.current){
            initRef.current = true;
            return;
        }

        onChange && onChange(tableFilters)
    }, [ 
        tableFilters,
        onChange
    ]);

    return (
        <TableFilter
            className="me-2"
            defaultActiveTab='role'
            tabs={tableFilterTabs}
            onOkButtonClicked={
                onTableFilterOkButtonClicked
            }
        />
    )
}

const mapStateToProps = (state) => {
	return {
		modules: state.Modules
	};
};

export default withNamespaces()(connect(mapStateToProps, null)(
    FilteringComponent
));
